module.exports = __webpack_public_path__ + "92dd90202fb6638dc764ddc7a88310d9.svg";